export function formatSsn(value: string) {
  const digitsOnly = value.replace(/\D/g, '').slice(0, 9)

  if (digitsOnly.length <= 3) {
    return digitsOnly
  }

  if (digitsOnly.length <= 5) {
    return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`
  }

  return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 5)}-${digitsOnly.slice(5)}`
}

export function formatSsnInput(value: string, currentValue: string) {
  if (!isMaskedStoredSsn(currentValue) || !/x/i.test(value)) {
    return formatSsn(value)
  }

  let start = 0
  while (
    start < value.length &&
    start < currentValue.length &&
    value[start] === currentValue[start]
  ) {
    start += 1
  }

  let valueEnd = value.length - 1
  let currentValueEnd = currentValue.length - 1
  while (
    valueEnd >= start &&
    currentValueEnd >= start &&
    value[valueEnd] === currentValue[currentValueEnd]
  ) {
    valueEnd -= 1
    currentValueEnd -= 1
  }

  return formatSsn(value.slice(start, valueEnd + 1))
}

export function formatPhoneNumber(value: string) {
  const digitsOnly = value.replace(/\D/g, '').slice(0, 10)

  if (digitsOnly.length === 0) {
    return ''
  }

  if (digitsOnly.length < 4) {
    return `(${digitsOnly}`
  }

  if (digitsOnly.length < 7) {
    return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`
  }

  return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`
}

export function getDigitsOnly(value: string) {
  return value.replace(/\D/g, '')
}

export function isMaskedStoredSsn(value: string) {
  return /^x{3}-x{2}-\d{4}$/i.test(value.trim())
}
